import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAltH } from "@fortawesome/pro-regular-svg-icons";
import { useConfig } from "@peracto/peracto-config";
import axios from "axios";
import ProductSlider from "./ProductSlider";

const Icon = () => (
  <div className="flex items-center justify-center w-full py-10">
    <FontAwesomeIcon icon={faArrowsAltH} size="6x" />
  </div>
);

const ProductSliderRenderer = ({ state: { skus = [] } }) => {
  const config = useConfig();
  const API_URL = config.get("api");

  const [products, setProducts] = useState([]);
  const [loadingError, setLoadingError] = useState(false);

  const loadProductData = async (skus) => {
    setLoadingError(false);

    if (skus.length > 0) {
      try {
        const skuQueryString = skus.map((sku) => `skus[]=${sku}`).join("&");

        if (skuQueryString?.length > 0) {
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          };

          const { data } = await axios.get(
            `${API_URL}/storefront/products-by-skus?${skuQueryString}`,
            {
              headers,
            }
          );

          const apiProducts = data?.["hydra:member"];

          const productsToShow = [];

          skus.forEach((sku) => {
            const apiProduct = apiProducts?.find(
              (product) => product.sku === sku
            );

            if (apiProduct) {
              return productsToShow.push(apiProduct);
            }
          });

          // Limit to 10 products maximum
          setProducts(productsToShow.slice(0, 10));
        }
      } catch (e) {
        setLoadingError(true);
        console.error(e);
      }
    }
  };

  useEffect(() => {
    const filteredSkus = skus.filter((sku) => !!sku);

    loadProductData(filteredSkus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skus]);

  return (
    <div className="py-2">
      {products?.length > 0 && !loadingError ? (
        <ProductSlider products={products} />
      ) : (
        <Icon />
      )}
    </div>
  );
};

export default ProductSliderRenderer;
